var THF = THF || {};
THF.Interface = THF.Interface || {};

(function($) {
	'use strict';

	function CompareFrame(args) {
		var defaults = {
			'container': '',
			'url': '',
			'modulesBeforeSubmissionContainerId': '',
			'modulesAfterSubmissionContainerId': '',
		};
		this.options = $.extend(true, {}, defaults, args);

		this.$container = this.options.container;

        this.injectIFrameUrl();
        this.autoResize(this.$container);
		this.addIframePostMessageListener(this.options);
	}

	CompareFrame.prototype.addIframePostMessageListener = function(options){

		window.addEventListener("message", 
			function(e){
				var isOrigin = e.origin === "https://compare.renaisis.com.au" | e.origin === "https://compare-uat.renaisis.com.au";
				
				if(isOrigin && e.data.action === "submitted"){
					
					$("#" + options.modulesBeforeSubmissionContainerId).addClass("hidden");
					$("#" + options.modulesAfterSubmissionContainerId).removeClass("hidden");
					window.scroll(0, 0);
				}	

		});
	}

	CompareFrame.prototype.injectIFrameUrl = function() {
		var asat = (new Date()).toISOString();
		var qs = '';
		var campaignCaptureQS = window.THF.Interface.CampaignCapture.getCapturedQueryString();
		if(campaignCaptureQS !== '') {
			qs = 'asat=' + asat + '&' + campaignCaptureQS;
		}
		var url = this.appendQueryString(this.options.url, qs);
        
        //re-assigning src url after page load to resolve 'null&_ga' error
        $(window).on('load', function() {
            $('iframe', this.$container).attr('src', url);
        });
	}
	
	CompareFrame.prototype.appendQueryString = function(url, queryString) {
		if(queryString.length === 0) {
			return url;
		}
		if(url.indexOf('?') >= 0) {
			return url + '&' + queryString;
		}
		else {
			return url + '?' + queryString;
		}
	}
	
	CompareFrame.prototype.autoResize = function(containerID) {
        $(window).on('load', function() {
		    iFrameResize({}, containerID + ' iframe');
        });
	}
	
	THF.Interface.CompareFrame = CompareFrame;
})(jQuery);
